import Api, { handleError } from '@/services/Api';

const API_URL = process.env.API_BASE;

export async function fetchGenerationHistoryList(params) {
  const url = `${API_URL}/generation_history/`;
  const { status, data } = await Api.get(url, { params }).catch(handleError);
  return { status, data };
}

export async function fetchGenerationHistoryFavorites(params) {
  const url = `${API_URL}/generation_history/favorites/`;
  const { status, data } = await Api.get(url, { params }).catch(handleError);
  return { status, data };
}

export async function fetchGenerationHistoryDetail(projectId) {
  const url = `${API_URL}/generation_history/${projectId}/`;
  const { status, data } = await Api.get(url).catch(handleError);
  return { status, data };
}

export async function fetchGenerationHistoryImageBlob(itemId, options = {}) {
  const url = `${API_URL}/generation_history/image/${itemId}/`;
  const params = {};
  if (options.itemType != null) {
    params.item_type = options.itemType;
  }
  if (options.index != null) {
    params.index = options.index;
  }
  const { status, data } = await Api.get(url, {
    params,
    responseType: 'blob',
  }).catch(handleError);
  if (status !== 200 || !data) {
    throw new Error('fetch_image_failed');
  }
  return data;
}

export async function toggleGenerationHistoryFavorite(payload) {
  const url = `${API_URL}/generation_history/favorite/toggle/`;
  const { status, data } = await Api.post(url, payload).catch(handleError);
  return { status, data };
}

export async function fetchGenerationHistoryFavoriteStatus(items) {
  const url = `${API_URL}/generation_history/favorite/status/`;
  const { status, data } = await Api.post(url, { items }).catch(handleError);
  return { status, data };
}
